import { colors } from "../../constants/colors";
import { FONT_SIZES } from "../../constants/fontSizes";

export const styles = {
  form: {
    width: "100%",
  },
  stack: {
    spacing: 3,
  },
  chipContainer: {
    mt: 1,
    mb: 2,
    display: "flex",
    flexWrap: "wrap",
    gap: 0.5,
  },
  chip: {
    backgroundColor: colors.blue_green.DEFAULT,
    color: colors.white.DEFAULT,
    animation: "chipColorTransition 3s ease-in-out",
    "@keyframes chipColorTransition": {
      "0%": {
        backgroundColor: colors.blue_green[300],
      },
      "100%": {
        backgroundColor: colors.blue_green.DEFAULT,
      },
    },
  },
  projectDescription: {
    "& .MuiInputBase-root": {
      minHeight: "72px", // 3 rows minimum
      maxHeight: "480px", // 20 rows maximum
      backgroundColor: "#ffffff",
      fontSize: FONT_SIZES.PARAGRAPH,
      "&:hover, &.Mui-focused": {
        backgroundColor: "#ffffff",
      },
    },
    mb: 2,
    "& .MuiFormHelperText-root": {
      color: colors.blue_green[300],
      fontSize: FONT_SIZES.TEXT_HINT,
    },
    "& .MuiInputLabel-root": {
      fontSize: FONT_SIZES.PARAGRAPH,
    },
  },
  infoIcon: {
    opacity: 0.5,
    ml: 1,
    fontSize: FONT_SIZES.ICON,
  },
  submitButton: {
    fontSize: FONT_SIZES.PARAGRAPH,
    background: `linear-gradient(90deg, ${colors.blue_green[600]} 10%, ${colors.prussian_blue[600]} 99%)`,
    "&:hover": {
      background: `linear-gradient(90deg, ${colors.blue_green[500]} 10%, ${colors.prussian_blue[500]} 99%)`,
    },
  },
  textField: {
    pt: { xs: 0, sm: 2 },
    "& .MuiInputBase-root": {
      backgroundColor: colors.white.DEFAULT,
      padding: "8px 12px",
      fontSize: FONT_SIZES.PARAGRAPH,
      "&:hover, &.Mui-focused": {
        backgroundColor: colors.white.DEFAULT,
      },
    },
    mb: 2,
    "& .MuiFormHelperText-root": {
      color: colors.blue_green[300],
      fontSize: FONT_SIZES.TEXT_HINT,
    },
    "& .MuiInputLabel-root": {
      fontSize: FONT_SIZES.PARAGRAPH,
    },
  },
  clearButton: {
    fontSize: FONT_SIZES.TEXT_HINT,
    textTransform: "none",
    padding: "2px 8px",
    minWidth: "auto",
    alignSelf: "flex-start",
    mb: 1,
    color: colors.blue_green.DEFAULT,
  },
  // Accordion styles
  accordion: {
    "&.MuiAccordion-root": {
      backgroundColor: "transparent",
      boxShadow: "none",
      "&:before": {
        display: "none",
      },
      "&.Mui-expanded": {
        margin: 0,
      },
    },
    "& .MuiAccordionSummary-root": {
      padding: 0,
      minHeight: "48px",
      "&.Mui-expanded": {
        minHeight: "48px",
      },
    },
    "& .MuiAccordionSummary-content": {
      margin: "12px 0",
      "&.Mui-expanded": {
        margin: "12px 0",
      },
    },
    "& .MuiAccordionDetails-root": {
      padding: "0 0 16px 0",
    },
  },
  accordionTitle: {
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    width: "100%",
    paddingBottom: "8px",
  },
  // TLD Dropdown styles
  tldDropdown: {
    "& .MuiSelect-select": {
      fontSize: FONT_SIZES.TEXT_HINT,
      minHeight: "1.4375em",
      padding: "8.5px 2px",
      display: "flex",
      alignItems: "center",
    },
    "&:before": {
      borderBottom: "none",
    },
    "&:after": {
      borderBottom: "none",
    },
  },
  tldLabel: {
    fontSize: FONT_SIZES.PARAGRAPH,
    color: "text.secondary",
    "&.Mui-focused": {
      color: "text.secondary",
    },
  },
  tldSelectedValue: {
    display: "flex",
    flexWrap: "wrap",
    gap: 0.1,
    fontSize: FONT_SIZES.TEXT_HINT,
  },
  // Job Type Select styles
  jobTypeSelect: {
    "& .MuiSelect-select": {
      fontSize: FONT_SIZES.PARAGRAPH,
    },
    "&:before": {
      borderBottom: "none",
    },
    "&:after": {
      borderBottom: "none",
    },
  },
  jobTypeLabel: {
    fontSize: FONT_SIZES.PARAGRAPH,
    color: "text.secondary",
    "&.Mui-focused": {
      color: "text.secondary",
    },
  },
};
